/* eslint-disable no-console */
import { Wrap, StyledButton as Button } from './styles';

import Layer from 'services/models/Layer';
import { sizeConvert } from 'services/utils/converters';
import withTimeout from 'services/utils/withTimeout';

import LabelSwitch from '../../../../../LabelSwitch';
import PopupImage from '../../../../../PopupImage';
import SliderColorPicker from '../../../../../SliderColorPicker';

import JpegJpgIconMapCliked from 'assets/img/jpeg-jpg-icon-map-clicked.svg';
import JpegJpgIconMap from 'assets/img/jpeg-jpg-icon-map.svg';
import AppContext from 'views/MapView/services/context';

import Icon from '@map/components/Icons';
import toGeoJSON from '@mapbox/togeojson';
import LinearProgress from '@material-ui/core/LinearProgress';
import FileInput from 'components/FileInput';
import EXIF from 'exif-js';
import parseGeoraster from 'georaster';
import GeoRasterLayer from 'georaster-layer-for-leaflet';
import JSZip from 'jszip';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useContext usado para forcener uma maneira de passar dados
 * pela arvore de componentes sem ter que passar props manualmente
 * em todos os níveis.
 * 
 * useMemo é um hook que retorna um valor memorizado.
 */
import { useState, useEffect, useContext, useMemo } from 'react';
import shp from 'shpjs';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import { useMap } from 'views/MapView/hooks';

import '@leaflet/includes';

/**
 * Função responsavel por adicionar arquivos nos formatos kml e Shapefile(.zip),
 * apos importar o arquivo é possivel escolher a cor com a qual a camada vai 
 * aparacer no mapa e escolher um rotulo.É criada tambem uma coluda ID para 
 * manipular a tabela de atributos, os titulos das colunas sao reduzidos pois 
 * a quantidade maxima permitida são de 10 caracteres. 
 */
export default ({ ...props }) => {
  const [typeFile, setTypeFile] = useState(null);
  const [file, setFile] = useState(null);
  const [fileIsValid, setFileIsValid] = useState(false);
  const [error, setError] = useState(null);
  const [warning, setWarning] = useState(null);
  const [warningInvalidImages, setWarningInvalidImages] = useState(false);
  const [warningTruncateColumn, setWarningTruncateColumn] = useState(null);
  const [layerName, setLayeName] = useState(null);
  const [layerType, setLayerType] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [layerStyle, setLayerStyle] = useState(null);
  const [columnLabel, setColumnLabel] = useState(null);
  const [geoJSON, setGeoJSON] = useState(null);
  const [raster, setRaster] = useState(null);
  const [fileRaster, setFileRaster] = useState(null);
  const [mapBounds, setMapBounds] = useState(null);
  const [originalLabelsList, setOriginalLabelsList] = useState([]);
  const [configureFinalLabelsList, setConfigureFinalLabelsList] = useState(false);
  const [finalLabelsList, setFinalLabelsList] = useState([]);
  const context = useContext(AppContext);

  const { map, addRasterLayer, addLayer, layers } = useMap();

  // Labels de colunas id's válidas  
  const arrValidId = useMemo(() => ['ID_GBA'], []);
  const defaultValue = '-- Nenhum --';
  const qtdToTruncate = 10;

  // Converte valores tipo data para string
  const convertValuesDateType = (gjson) => {
    
    let propertiesLayer = gjson.features[0].properties;                
    let dateKeys = Object.keys(propertiesLayer).filter((k) => propertiesLayer[k] instanceof Date);
    
    gjson.features.forEach(function(feature) {      
      dateKeys.forEach(function(dt) {
        feature.properties[dt] = feature.properties[dt].toString();
      });      
    });

    return gjson;
  };

  useEffect(() => {
    if (file) {      
      let fileReader = new FileReader();     

      let extensionFile = file.name.split('.').pop();
      setFileType(
        extensionFile.toLowerCase() === 'jpeg' || extensionFile.toLowerCase() === 'jpg'?
         'jpg/jpeg':
         extensionFile
      );
      setLayeName(file.name.replace(`.${extensionFile}`, ''));
      setLayerStyle(null);
      
      fileReader.onloadend = (e) => {
        if (extensionFile.toLowerCase() === 'kml') {
          if (file.size > 200 * 1000 * 1000) { // 200MB
            setError('A importação não pode ser realizada, o arquivo excede o tamanho de 200MB. '); // mensagem de erro
            setFileIsValid(false);
          }else {
            let gJson = toGeoJSON.kml(
              new DOMParser().parseFromString(fileReader.result, 'text/xml')
            );          
            
            if (gJson && gJson.features.length > 0) {
  
              // Remoção de atributos de estilo inseridos pela biblioteca toGeoJSON
              gJson.features.forEach(function(feature) {
                delete feature.properties.stroke;
                delete feature.properties["stroke-opacity"];
                delete feature.properties["fill-opacity"];
                // Remove propriedades das feições, cujo valor sejanum objeto,
                // exceto 'envelope' e 'bbox' para evitar erro ao abrir a tabela de atributos  
                let arrPropertiesFeatureInfo = Object.entries(feature.properties);
                let filteredNonObjValues = arrPropertiesFeatureInfo.filter(([key, value]) => typeof value !== 'object' || ['envelope', 'bbox'].includes(key));      
                let justNonObjValues = Object.fromEntries(filteredNonObjValues); 
                feature.properties = {               
                  ...justNonObjValues,                
                }
              });
  
              setGeoJSON(gJson);
            } else {
              setError('Não foi encontrada nenhuma camada no arquivo.');
              setFileIsValid(false);
            }
          }
        
        } else if (extensionFile.toLowerCase() === 'zip') {
          if (file.size > 200 * 1000 * 1000) { // 200MB
            setError('A importação não pode ser realizada, o arquivo excede o tamanho de 200MB. ');
            setFileIsValid(false);
          }else{  
            let zip = new JSZip();
            zip.loadAsync(fileReader.result).then((data) => {
              if (data.files) {
                let isJpgJpeg = false;
                let shpName;
                let requiredExtensions = ['shp', 'shx', 'dbf', 'prj'];
                let foundExtensions = {
                  shp: false,
                  shx: false,
                  dbf: false,
                  prj: false,
                };
                let foundFiles = [];
                let areSameFile = true;
  
                const extSatisfied = () => {
                  return (
                    foundExtensions.shp &&
                    foundExtensions.shx &&
                    foundExtensions.dbf &&
                    foundExtensions.prj
                  );
                };
  
                Object.keys(data.files).forEach((k) => {
                  let ext = k.split('.').pop();
                  if (ext && requiredExtensions.includes(ext.toLowerCase())) {
                    foundExtensions[ext.toLowerCase()] = true;
                    foundFiles.push(k.replace(`.${ext}`, ''));
                    if (ext.toLowerCase() === 'shp' && !shpName)
                      shpName = k.replace(`.${ext}`, '');
                  }
                  else if(ext.toLowerCase() === "jpg" || ext.toLowerCase() === "jpeg"){
                    isJpgJpeg = true;
                  }
                });
                if (foundFiles.length > 0 && shpName) {
                  foundFiles.forEach((ff) => {
                    if (ff !== shpName) areSameFile = false;
                  });
                }
                if (extSatisfied() && areSameFile && !isJpgJpeg) {
                  shp(fileReader.result)
                    .then((gjson) => {                       
                      if (Array.isArray(gjson)) {
                        setError('O arquivo não deve ter mais que uma camada!');
                        setFileIsValid(false);
                      } else if (gjson && gjson.features.length > 0) {                        
                        setGeoJSON(convertValuesDateType(gjson));
                      } else {
                        setError('Não foi encontrada nenhuma camada no arquivo.');
                        setFileIsValid(false);
                      }
                    })
                    .catch((errorLayer) => {
                      setError(
                        errorLayer === 'Error: no layers founds'
                          ? 'Não foi encontrada nenhuma camada no arquivo.'
                          : `Falha ao importar: ${errorLayer}`
                      );
                      setFileIsValid(false);
                    });
                } else if(isJpgJpeg && extSatisfied()){
                  setError('Arquivos com múltiplas extensões não podem ser importados.');
                  setFileIsValid(false);
                } else if(isJpgJpeg === true){
                  const getExifData = (file) => {
                    return new Promise((resolve, reject) => {
                      if (!file) {
                        reject("invalid");
                        return;
                      }
                  
                      let reader = new FileReader();
                  
                      reader.onload = function (e) {
                        EXIF.getData(file, function () {
                          let allMetaData = EXIF.getAllTags(this);
                          if((!allMetaData) || (Object.values(allMetaData).length === 0)){
                            resolve("invalid");
                          }else if("GPSLatitudeRef" in allMetaData && "GPSLongitudeRef" in allMetaData){

                          let lat = allMetaData.GPSLatitude[0] + ((allMetaData.GPSLatitude[1] / 60) + (allMetaData.GPSLatitude[2] / 3600));
                          let log = allMetaData.GPSLongitude[0] + ((allMetaData.GPSLongitude[1] / 60) + (allMetaData.GPSLongitude[2] / 3600));
                  
                          // Determina se a latitude é norte ou sul
                          if (allMetaData.GPSLatitudeRef === 'S') {
                            lat = lat * -1;
                          }
                  
                          // Determina se a longitude é leste ou oeste
                          if (allMetaData.GPSLongitudeRef === 'W') {
                            log = log * -1;
                          }
                          if((lat >= -90 && lat <= 90) && (log >= -180 && log <= 180)){
                              // Função para verificar se as coordenadas estão na Bahia
                              const withinLimit = (latitude, longitude) => {
                                // Limites geográficos aproximados da Bahia
                                const limitNorth = -8.3;
                                const limitSouthern = -18.50;
                                const limiteWest = -47;
                                const limiteEast = -37;

                                // Verificar se as coordenadas estão dentro dos limites da Bahia
                                return (
                                  latitude >= limitSouthern &&
                                  latitude <= limitNorth &&
                                  longitude >= limiteWest &&
                                  longitude <= limiteEast
                                );
                              };
                              if (withinLimit(lat,log) === true) {
                                let feature = {
                                  type: 'Feature',
                                  geometry: {
                                    type: 'Point',
                                    coordinates: [log, lat]
                                  },
                                  properties: {
                                    nm_foto: file.name,
                                    Latitude: lat,
                                    Longitude: log
                                  },
                                  imageUrl: e.target.result,
                                  popupOpen: false
                                };    
                                resolve(feature); 
                              } else {
                                resolve("invalid");
                              }                            
                          }else{
                            resolve("invalid");
                          }
                        }else{
                          resolve("invalid");                      
                        }
                        });
                      };
                  
                      // Leia o arquivo como uma URL de dados
                      reader.readAsDataURL(file);
                    });
                  };

                  // Itera sobre as entradas do zip
                  let promisses = Object.keys(data.files).map((nameFile) => {
                    let file = data.files[nameFile];

                    // Cria um Blob com os dados do arquivo
                    return file.async("uint8array").then((conteudo) => {
                      return new Blob([conteudo]);
                    });
                  });

                  // Aguarda todas as promessas serem resolvidas
                  Promise.all(promisses).then((blobs) => {
                    // Aqui 'blobs' é um array de Blobs, cada um representando um arquivo do zip

                    // Exemplo: Cria um novo File para cada Blob
                    let newsFiles = blobs.map((blob, index) => {
                      return new File([blob], Object.keys(data.files)[index], { type: 'image/jpg' });
                    });

                    // Agora 'novosArquivos' é um array de File, cada um representando um arquivo do zip
                    let featuresJpg = newsFiles.map(async (file) => {
                      try {
                        const result = await getExifData(file);
                        return result; // Retorna a feature para ser resolvida pela Promise.all
                      } catch (error) {
                        console.error(error);
                        throw error; // Propaga o erro para ser tratado por Promise.all
                      }
                    });

                    Promise.all(featuresJpg)
                      .then((features) => {
                        let validFeatures = features.filter((elemento) => elemento !== 'invalid');
                        if(validFeatures.length > 0 && features.length === validFeatures.length){
                          //seta o GeoJSON depois de processar todas as features
                          setGeoJSON({
                            type: 'FeatureCollection', 
                            features: validFeatures, 
                            fileName: file.name.replace(`.${extensionFile}`, ''),
                          });
                        }else if(validFeatures.length > 0 && features.length > validFeatures.length){
                          setWarningInvalidImages(true);
                          //seta o GeoJSON depois de processar todas as features
                          setGeoJSON({
                            type: 'FeatureCollection', 
                            features: validFeatures, 
                            fileName: file.name.replace(`.${extensionFile}`, ''),
                          });
                        }else{
                          setError('Ocorreu um erro durante a importação do arquivo.');
                          setFileIsValid(false);
                        }
                      })
                      .catch((error) => {
                        console.error("Erro ao processar as features:", error);
                      });
                  });

                }else if(!extSatisfied() && !isJpgJpeg){
                  setError(
                    'O arquivo importado está vazio ou não possui a extensão JPG/JPEG'
                  );
                  setFileIsValid(false);
                } else {
                  if (!extSatisfied()) {
                    setError(
                      'Não foi possível inserir os arquivos. Arquivo incompleto.'
                    );
                    setFileIsValid(false);
                  } else if (!areSameFile) {
                    setError('O arquivo não deve ter mais que uma camada!');
                    setFileIsValid(false);
                  } else {
                    setError('Não foi encontrada nenhuma camada no arquivo.');
                    setFileIsValid(false);
                  }
                }
              }
            });
          }
        } else if (['tiff', 'tif'].includes(extensionFile.toLowerCase())) {   
          if (file.size > 200 * 1000 * 1000) { // 200MB
            setError('A importação não pode ser realizada, o arquivo excede o tamanho de 200MB. ');
            setFileIsValid(false);
          } else {
            let fileReaderResult = fileReader.result;                     
            setFileRaster(file);  
            withTimeout(10 * 1000, async () => {  // 10s
                return parseGeoraster(fileReaderResult);                
              })
              .then((georaster) => {                
                let geoRasterLayer = new GeoRasterLayer({
                    georaster: georaster,                  
                    resolution: 256, // Esse valor se mostrou suficientimente bom para exibir os rasters em boa qualidade para as nossas necessidades
                    pane: 'mixedPane',
                });
                setRaster(geoRasterLayer);              
              })
              .catch((e) => {                
                setError('Não foi possível importar o arquivo. Erro desconhecido.'); 
              });              
          }
        } else if (['jpg', 'jpeg'].includes(extensionFile.toLowerCase())) {
          EXIF.getData(file, function() {

            var allMetaData = EXIF.getAllTags(this);
            if((!allMetaData) || (Object.values(allMetaData).length === 0)){

              setFileIsValid(false);
              setError(
                'A imagem importada deve conter metadados.'
              );

            }else if("GPSLatitudeRef" in allMetaData && "GPSLongitudeRef" in allMetaData){

              var lat = allMetaData.GPSLatitude[0]+((allMetaData.GPSLatitude[1]/60) + (allMetaData.GPSLatitude[2]/3600));
              var log = allMetaData.GPSLongitude[0]+((allMetaData.GPSLongitude[1]/60) + (allMetaData.GPSLongitude[2]/3600));
              // Determina se a latitude é norte ou sul
              if(allMetaData.GPSLatitudeRef === 'S'){
                lat = lat * -1;
              }
              // Determina se a longitude é leste ou oeste
              if(allMetaData.GPSLongitudeRef === 'W'){
                log = log * -1;
              }
              if((lat >= -90 && lat <= 90) && (log >= -180 && log <= 180)){
                // Event listener para quando o usuário carregar um arquivo
                if (file) {
                  var reader = new FileReader();
    
                  reader.onload = function (e) {
                    var pointFeature = {
                      type: 'FeatureCollection', 
                      features: [{
                        type: 'Feature',
                        geometry: {
                          type: 'Point',
                          coordinates: [log, lat]
                        },
                        properties:{
                          nm_foto: file.name,
                          Latitude: lat,
                          Longitude: log
                        },
                        imageUrl: e.target.result,
                        popupOpen: false
                      }], 
                      fileName: file.name.replace(`.${extensionFile}`, ''),
                    }

                    setGeoJSON(pointFeature);
                  };
    
                  // Leia o arquivo como uma URL de dados
                  reader.readAsDataURL(file);
                }
              }else{
                setFileIsValid(false);
                setError(
                  'A localização da imagem importada é inválida.'
                );
              }
            }else{
            setFileIsValid(false);
            setError(
              'A imagem importada deve conter metadados de geolocalização.'
            );
          }
          });

        }
      };

      switch (extensionFile.toLowerCase()) {
        case 'zip':
          setTypeFile('SHP');
          fileReader.readAsArrayBuffer(file);
          break;
        case 'kml':
          setTypeFile('KML');
          fileReader.readAsText(file);
          break;
        case 'tiff':
          setTypeFile('TIFF');
          fileReader.readAsArrayBuffer(file);
          break;
        case 'tif':
          setTypeFile('TIFF');
          fileReader.readAsArrayBuffer(file);
          break;
        case 'jpg':
          setTypeFile('JPG/JPEG');
          fileReader.readAsArrayBuffer(file);
          break;
        case 'jpeg':
          setTypeFile('JPG/JPEG');
          fileReader.readAsArrayBuffer(file);
          break;
        default:
          setTypeFile(null);
      }
    } else {
      setError(null);
      setFileIsValid(false);
      setGeoJSON(null);
      setRaster(null);
      setLayerType(null);
    }
  }, [file, map]);

  useEffect(() => {
    if (map && !mapBounds) {
      setMapBounds(map.options.maxBounds);
    }
  }, [map, mapBounds]);

  useEffect(() => {
    setWarning(null);
    if (geoJSON && mapBounds) {
      let geometryType = geoJSON.features[0].geometry.type;
      if (geometryType === 'Point' || geometryType === 'MultiPoint') {
        setLayerType('Point');
      } else if (
        geometryType === 'Line' ||
        geometryType === 'LineString' ||
        geometryType === 'MultiLineString'
      ) {
        setLayerType('Line');
      } else if (
        geometryType === 'Polygon' ||
        geometryType === 'MultiPolygon' ||
        geometryType === 'GeometryCollection'
      ) {
        setLayerType('Polygon');
      }

      let bounds = L.geoJSON(geoJSON).getBounds();
      if (mapBounds.contains(bounds) || mapBounds.intersects(bounds)) {
        setFileIsValid(true);
      } else {
        setFileIsValid(false);
        setError(
          'Pelo menos uma parte da camada deve estar dentro dos limites do módulo!'
        );
      }
      
      if (fileIsValid) {
        let originalLabelsListOfUseEffect = [];
        let propertiesLayer = geoJSON.features[0].properties;            
        Object.keys(propertiesLayer).forEach(
          (k) => (originalLabelsListOfUseEffect.push({label: k, value: k}))
        );        
        setOriginalLabelsList(originalLabelsListOfUseEffect);   
      }
    } else if (raster) {
      // Validações para arquivos .tiff      
      if (mapBounds.contains(raster.getBounds()) || mapBounds.intersects(raster.getBounds())) {
        setFileIsValid(true);
      } else {
        setFileIsValid(false);
        setError(
          'Pelo menos uma parte da camada deve estar dentro dos limites do módulo!'
        );
      }      
    }
  }, [typeFile, geoJSON, mapBounds, fileIsValid, raster]);

  useEffect(() => {
    // Realiza intervenções (criação de coluna id, valores únicos de id e truncagem de label das colunas) 
    // nas propriedades do GeoJSON resultante do arquivo recém importado, se nescessário
    if (fileIsValid && geoJSON && originalLabelsList.length > 0) {
      let arrPropertiresLabel = [];
      let arrFoundedIds = [];
      let arrColumnsToTruncate = [];
      
      /**
       * Trunca label das colunas do array informado conforme
       * quantidade de caracteres desejada
       * 
       * @param {Array} arrColumnsToTruncate
       * @param {Object} feature
       */
      const truncateColumns = (paramArrColumnsToTruncate, feature) => {
        // Se houver colunas para truncar
        if (paramArrColumnsToTruncate.length > 0) {
          paramArrColumnsToTruncate.forEach((labelToTruncate) => {
            // Armazena valor da coluna a ser truncada
            let valueLabelToTruncate = feature.properties[labelToTruncate];
            // Cria propriedade labal da coluna truncada e define valor armazenado anteriormente
            feature.properties[labelToTruncate.substring(0, qtdToTruncate)] = valueLabelToTruncate;
            // Deleta propriedade
            delete feature.properties[labelToTruncate];
          });
          setWarningTruncateColumn(
            'O título de algumas colunas foram reduzidos, pois excedem a quantidade máxima de ' + qtdToTruncate + ' caracteres permitidos pelo sistema.'
          );
        }
      }

      // Obtém lista de labels das colunas      
      arrPropertiresLabel = originalLabelsList.map((label) => {
        return label.value;
      });      
      // Obtém array de possíveis colunas id's válidas na camada      
      arrFoundedIds = arrPropertiresLabel.filter((label) => arrValidId.includes(label));
      // Obtém as feições
      let geoJsonFeatures = geoJSON.features;
      // Obtém colunas com labels acima da quantidade de caracteres desejada      
      arrColumnsToTruncate = arrPropertiresLabel.filter((label) => label.length > qtdToTruncate && label !== defaultValue);      
      // Se possuir alguma coluna 'id'
      if (arrFoundedIds.length > 0) {                     
        // Cria valores únicos de ID_GBA's   
        geoJsonFeatures.forEach((feature, index) => {
          // Considera o primeiro label de 'id' encontrado como a coluna 'id' padrão
          feature.properties[arrFoundedIds[0]] = ++index;
          truncateColumns(arrColumnsToTruncate, feature);
        });
        setWarning(
          'Foram alterados os valores da coluna \'ID_GBA\' garantindo a unicidade e possibilitando a manipulação da tabela de atributo.'
        );        
      } else {        
        // Cria coluna ID_GBA e insere valor sequencial do tipo inteiro
        geoJsonFeatures.forEach((feature, index) => {        
          feature.properties = {
            ID_GBA: ++index,
            ...feature.properties,
          }
          truncateColumns(arrColumnsToTruncate, feature);
        });
        setWarning(
          'O sistema irá adicionar automaticamente a coluna “ID_GBA” na tabela de atributo do arquivo importado.'
        );
      }
      
      setConfigureFinalLabelsList(true);           
    }
  }, [fileIsValid, arrValidId, geoJSON, originalLabelsList]);

  useEffect(() => {
    if (geoJSON && configureFinalLabelsList) {
      let labelsList = [];
      let propertiesLayer = geoJSON.features[0].properties;            
      Object.keys(propertiesLayer).forEach(
        (k) => (labelsList.push({label: k, value: k}))
      );      
      setFinalLabelsList(labelsList); 
    }
  }, [geoJSON, configureFinalLabelsList]);
 
  /**
   * Manipula submit do formulário
   */
  const handleClick = (e) => {     
    if (geoJSON) {      
      let customRender = L.canvas({ pane: 'mixedPane' });
      let options = {
        pane: 'mixedPane',
        style: layerStyle,
        renderer: customRender,
      };
      if (layerType === 'Point'){
        options = {
          ...options,
          pointToLayer: function (feature, latlng) {
            let circleMarker = L.circleMarker(latlng, {
              pane: 'mixedPane',
              ...layerStyle,
              renderer: customRender,            
            })

            if (fileType === "jpg/jpeg" || feature?.imageUrl) {
              let iconDefaultJpegJpg = L.icon({
                  pane: 'mixedPane',
                  renderer: customRender,
                  iconUrl: JpegJpgIconMap,
                  iconAnchor: [9, 9],
              });
              let iconClikedJpegJpg = L.icon({
                  pane: 'mixedPane',
                  renderer: customRender,
                  iconUrl: JpegJpgIconMapCliked,
                  iconAnchor: [9, 9],
              });
              var markerJpegJpg = L.marker(latlng, {
                pane: 'mixedPane',
                renderer: customRender,
                icon: iconDefaultJpegJpg                
              });
              
              markerJpegJpg.on('popupopen', function(e) {
                e.target.setIcon(iconClikedJpegJpg);
                feature.popupOpen = true;
              });
              markerJpegJpg.on('popupclose', function(e) {
                if (map.hasLayer(e.target)) {
                  e.target.setIcon(iconDefaultJpegJpg);
                  feature.popupOpen = false;
                }
              });

              let popup = L.popup({
                autoClose: false, 
                closeOnClick: false,
                closeButton: false,
                className: 'custom-leaflet-popup-jpg-jpeg-layer',              
              }).setContent(PopupImage(feature.imageUrl, markerJpegJpg));              
              markerJpegJpg.bindPopup(popup);              

              return markerJpegJpg;
            }
            return circleMarker;
          }
        }
      }

      let geoJsonLayer = L.geoJSON(geoJSON, options);
      let layerToAdd = new Layer(
        null,
        'importada',
        null,
        layerName,
        null,
        null,
        null,
        null,
        null
      );
      layerToAdd.setFileType(fileType);
      layerToAdd.setLeafletLayer(geoJsonLayer);      
      layerToAdd.setLayerStyle(layerStyle);
      addLayer(layerToAdd);
      layers.forEach((layer) => {
        layer.addLabel(layerToAdd, columnLabel);
      });      
    } else if (raster) {      
      let rasterLayerToAdd = new Layer(
        null,
        'importada-raster',
        null,
        layerName,
        null,
        null,
        null,
        null,
        null
      );
      rasterLayerToAdd.setFileType(fileType);
      rasterLayerToAdd.setLeafletLayer(raster);
      rasterLayerToAdd.setGeoRasterLayer(fileRaster);
      addRasterLayer(rasterLayerToAdd);
    }    
    context.genericSetContextProp('layersCatalogIsOpened', false);        
  };

  /**
   * @returns Algumas frases  para interação com o usuario, ajuda-lo a usar 
   * os recursos entre eles os formatos que sao possiveis de serem importados,
   * escolher as cor da camada importada e adicionar um rotulo se quiser.
   */
  return (
    <Wrap>
      <div className="file-area">
        <FileInput
          accept=".zip,.kml,.tiff,.tif,.jpeg,.jpg"
          onChange={(newFile) => setFile(newFile)}
          extensionCheckMsg="Não foi possível inserir o arquivo. Arquivo com formato não permitido."
          disabled={Boolean(file)}
        />
        {file ? (
          <div className="layer">
            <div className="layer-body">
              <div className="title">
                <div style={{ display: 'flex', width: '100%' }}>
                  <p>{file.name}</p>
                  <span> {file.size && `(${sizeConvert(file.size)})`}</span>
                </div>
                <span>{!geoJSON && !raster && !error ? 'processando...' : '100%'}</span>
              </div>
              <LinearProgress
                variant={!geoJSON && !raster && !error ? 'indeterminate' : 'determinate'}
                className={`fake-progress ${error && 'error'}`}
                value={100}
              />
              {error && <p className="error">{error}</p>}
              {warning && <p className="warning">{warning}</p>}
              {warningTruncateColumn && <p className="warning">{warningTruncateColumn}</p>}
              {warningInvalidImages && <p className="warning">Alguns arquivos são inválidos e não serão importados.</p>}

            </div>
            <button
              className="remove-button"
              onClick={() => {
                setWarningInvalidImages(null);
                setFile(null);                
                setOriginalLabelsList([]);
              }}
            >
              <Icon i="map-trash" width="10" height="11" />
            </button>
          </div>
        ) : (
          <p
            style={{
              textAlign: 'center',
              fontSize: 12,
              padding: '0 70px',
              margin: 0,
            }}
          >
            São reconhecidos os formatos Shapefile, KML, TIFF, TIF, JPEG e JPG, com até 200MB. Os arquivos Shapefile devem ser carregados compactados na extensão .zip
          </p>
        )}
      </div>

      <div className="container-configure-label">
        <div className="select-symbology">
          <SliderColorPicker 
            geometryType={layerType || 'Polygon'}
            selectedSymbology={layerStyle}
            onSelect={(s) => setLayerStyle(s)}
            disabled={!layerType || error}
            autoSelect={false}
          />
        </div>
        <div>
          <LabelSwitch
            onSelect={(s) => setColumnLabel(s)}
            disabled={!layerType || error}
            labelsList={finalLabelsList}
            autoSelect={false}
            defaultValue={defaultValue}
          />
        </div>
      </div>

      <footer>
        <div className="button-area">
          <Button
            variant="contained"
            disabled={!((geoJSON || raster) && fileIsValid)}
            onClick={handleClick}
          >
            Adicionar
          </Button>
        </div>
      </footer>
    </Wrap>
  );
};
